/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".traveller[_ngcontent-%COMP%]{border-bottom:1px dotted #d3d3d3;margin-bottom:20px;margin-top:20px;padding-bottom:20px}.price[_ngcontent-%COMP%]{font-weight:600;color:#e21937;font-size:large;text-align:right}.alert-error[_ngcontent-%COMP%]{color:#e21937}[_nghost-%COMP%]     mat-icon{vertical-align:middle}"];
export { styles as styles };
